export const content = {
  hero: {
    title: "Agency Portal",
    subtitle: "Partner with RiverBlue to help your clients identify stalled deals and revenue risk before they're lost.",
    badges: [
      "Real Estate + Medspas",
      "Read-only OAuth",
      "Tenant-isolated data",
    ],
    valueProp: "Identify stalled deals and revenue risk before they're lost.",
    minimumFit: "Best for agencies serving teams with 3+ sales agents or $500K+ annual revenue.",
  },
  howAgenciesUseIt: {
    branded: {
      title: "Branded (Default)",
      bullets: [
        "Use RiverBlue under the RiverBlue brand",
        "Bundle into your existing services",
        "Low risk, fast client adoption",
        "No support burden on your team",
      ],
    },
    whiteLabel: {
      title: "White-Label (Upgrade)",
      bullets: [
        "Your brand, your pricing",
        "Keep 100% of the markup",
        "Offer as a standalone product",
        "Unlocked after proven demand (1–3 paying clients)",
      ],
    },
    note: "White-label access is unlocked after demonstrated client demand.",
  },
  whatClientsSee: {
    title: "What Clients See",
    outcomes: [
      "Revenue at risk, quantified",
      "Deals stuck too long",
      "Clear next actions",
      "Weekly exec-ready insights",
    ],
  },
  security: {
    title: "Security & Data Safety",
    assurances: [
      "Read-only OAuth (no passwords, no write-back)",
      "Tenant-isolated data per client",
      "Disconnect access anytime",
      "Data deletion available on request",
    ],
  },
  pilot: {
    title: "Agency Pilot",
    description: [
      "30-day pilot with one client account",
      "Success = stalled deals identified + actions an agency can present to clients.",
      "After the pilot: continue on a paid plan or unlock white-label eligibility.",
    ],
    cta: {
      primary: "Apply for Agency Pilot",
      secondary: "Request White-Label Eligibility",
    },
  },
  socialProof: "Currently piloting with agencies serving Real Estate and Medspa clients.",
};
